import http from 'common-module/src/util/http';
import { Message } from 'zk-ui';

const subMsgAssertResult = (res) => {
  const { code, msg, subMsg } = res.data;
  if (code !== '200') {
    Message({
      message: subMsg ? `${msg}，${subMsg}` : msg,
      type: 'error',
      duration: 2000
    });
    return false;
  }
  return true;
};

export async function loadNewFieldType() {
  return http.post('/form-control/list', {});
}

export async function addField(data) {
  return http.post('/profile/custom-field/add', data, {
    assertResult: res => subMsgAssertResult(res),
    showError: false
  });
}
export const updateField = async data => {
  return http.post('/profile/custom-field/update', data, {
    assertResult: res => subMsgAssertResult(res),
    showError: false
  });
};
export const loadFieldInfo = async id => {
  return http.post('/profile/custom-field/detail', { id });
};

// 公式字段返回类型下拉框接口
export async function formulaBackType() {
  return http.post('/profile/custom-field/get/formula-field-type');
}

// 公式计算字段条件
export async function formulaExpressCondition(data = {}) {
  return http.post('/profile/custom-field/formula-express-condition', data);
}

// 校验公式字段合法性
export async function formulaCheckExpression(data = {}) {
  return await http.post('/profile/custom-field/check/expression', data, {
    assertResult: (res) => {
      if (res.data.code !== '200') {
        res.data = {
          isLegal: false,
          reason: res.data.subMsg
        };
        return true;
      }
      return true;
    }
  });
}

// 公式自定义字段，查询关联字段
export async function getFormulaConditionOptions(data = {}) {
  return http.post('/profile/custom-field/formula-condition-options', data);
}

// 查询分组下成员信息
export async function getUserGroupDepartment(data = {}) {
  return http.post('/dept/user-group-by-department', data);
}

// 校验数值字段合法性
export async function numberCheckExpression(data = {}) {
  return http.post('/profile/custom-field/check/number', data);
}


